define("shared/components/shared/color-picker", ["exports", "@ember/component", "@ember/array", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@simonwep/pickr", "@simonwep/pickr/dist/themes/monolith.min.css", "later/utils/compare-strings", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _array, _object, _runloop, _service, _component2, _tracking, _pickr, _monolithMin, _compareStrings, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _addColorToCache, _isColorListed, _addRecentColor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@simonwep/pickr",0,"@simonwep/pickr/dist/themes/monolith.min.css",0,"later/utils/compare-strings",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    {{did-insert this.initializeColorPicker}}
    {{did-update (fn this.onColorChangeFromOutsideColorPicker @selectedColor) @selectedColor}}
    {{will-destroy this.destroyColorPicker}}
  >
    {{#if (is-present this.headerElement)}}
      <Shared::Portal @destinationElement={{this.headerId}}>
        {{! Header }}
        <Shared::ColorPicker::Header
          @close={{this.closeColorPicker}}
          @menuTitle={{@menuTitle}}
          @qaClass={{@closeButtonQaClass}}
        />
        <div class="cLB--stylePicker__divider"></div>
      </Shared::Portal>
    {{/if}}
  
    {{#if (is-present this.upgradeElement)}}
      <Shared::Portal @destinationElement={{this.upgradeId}}>
        {{! Upgrade }}
        {{yield this.closeColorPicker to="upgrade"}}
      </Shared::Portal>
    {{/if}}
  
    {{#if (and (is-present this.recentColorsElement) this.shouldShowRecentColors)}}
      <Shared::Portal @destinationElement={{this.recentColorsId}}>
        {{#if @hasAccess}}
          {{! Recent Colors }}
          <div class="cLB--stylePicker__divider">{{t "linkinbio.color_picker.recent"}}</div>
          <Shared::ColorPicker::Swatches
            @colors={{this.recentColors}}
            @id={{@id}}
            @onClick={{this.onColorChangeFromOutsideColorPicker}}
            @selectedColor={{@selectedColor}}
          />
        {{/if}}
      </Shared::Portal>
    {{/if}}
  </div>
  {{#if (has-block "selector")}}
    {{yield this.openColorPicker to="selector"}}
  {{else}}
    <Shared::ColorPicker::Selector
      @color={{@selectedColor}}
      @onClick={{this.openColorPicker}}
      @qaClass={{@selectorQaClass}}
    />
  {{/if}}
  */
  {
    "id": "W47el8Yd",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"initializeColorPicker\"]]],null],[4,[38,1],[[28,[37,2],[[30,0,[\"onColorChangeFromOutsideColorPicker\"]],[30,1]],null],[30,1]],null],[4,[38,3],[[30,0,[\"destroyColorPicker\"]]],null],[12],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"headerElement\"]]],null],[[[1,\"    \"],[8,[39,6],null,[[\"@destinationElement\"],[[30,0,[\"headerId\"]]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[39,7],null,[[\"@close\",\"@menuTitle\",\"@qaClass\"],[[30,0,[\"closeColorPicker\"]],[30,2],[30,3]]],null],[1,\"\\n      \"],[10,0],[14,0,\"cLB--stylePicker__divider\"],[12],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"upgradeElement\"]]],null],[[[1,\"    \"],[8,[39,6],null,[[\"@destinationElement\"],[[30,0,[\"upgradeId\"]]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[18,7,[[30,0,[\"closeColorPicker\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,9],[[28,[37,5],[[30,0,[\"recentColorsElement\"]]],null],[30,0,[\"shouldShowRecentColors\"]]],null],[[[1,\"    \"],[8,[39,6],null,[[\"@destinationElement\"],[[30,0,[\"recentColorsId\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,4],[[[1,\"        \"],[10,0],[14,0,\"cLB--stylePicker__divider\"],[12],[1,[28,[35,10],[\"linkinbio.color_picker.recent\"],null]],[13],[1,\"\\n        \"],[8,[39,11],null,[[\"@colors\",\"@id\",\"@onClick\",\"@selectedColor\"],[[30,0,[\"recentColors\"]],[30,5],[30,0,[\"onColorChangeFromOutsideColorPicker\"]],[30,1]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"  \"],[18,8,[[30,0,[\"openColorPicker\"]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,13],null,[[\"@color\",\"@onClick\",\"@qaClass\"],[[30,1],[30,0,[\"openColorPicker\"]],[30,6]]],null],[1,\"\\n\"]],[]]]],[\"@selectedColor\",\"@menuTitle\",\"@closeButtonQaClass\",\"@hasAccess\",\"@id\",\"@selectorQaClass\",\"&upgrade\",\"&selector\"],false,[\"did-insert\",\"did-update\",\"fn\",\"will-destroy\",\"if\",\"is-present\",\"shared/portal\",\"shared/color-picker/header\",\"yield\",\"and\",\"t\",\"shared/color-picker/swatches\",\"has-block\",\"shared/color-picker/selector\"]]",
    "moduleName": "shared/components/shared/color-picker.hbs",
    "isStrictMode": false
  });
  let ColorPickerComponent = _exports.default = (_class = (_addColorToCache = /*#__PURE__*/new WeakSet(), _isColorListed = /*#__PURE__*/new WeakSet(), _addRecentColor = /*#__PURE__*/new WeakSet(), class ColorPickerComponent extends _component2.default {
    get swatchColors() {
      return this.args.swatchColors || this.defaultSwatchColors;
    }
    get shouldShowRecentColors() {
      return this.args.showRecentColors ?? true;
    }
    get cacheKey() {
      return `${this.args.id}_${this.auth.currentAccount.id}`;
    }
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _addRecentColor);
      _classPrivateMethodInitSpec(this, _isColorListed);
      _classPrivateMethodInitSpec(this, _addColorToCache);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "headerElement", _descriptor4, this);
      _initializerDefineProperty(this, "pickr", _descriptor5, this);
      _initializerDefineProperty(this, "pickrElement", _descriptor6, this);
      _initializerDefineProperty(this, "recentColors", _descriptor7, this);
      _initializerDefineProperty(this, "recentColorsElement", _descriptor8, this);
      _initializerDefineProperty(this, "upgradeElement", _descriptor9, this);
      _defineProperty(this, "recentColorsId", `color-picker-recent-colors-${(0, _uuid.default)()}`);
      _defineProperty(this, "headerId", `color-picker-header-${(0, _uuid.default)()}`);
      _defineProperty(this, "upgradeId", `color-picker-upgrade-${(0, _uuid.default)()}`);
      _defineProperty(this, "defaultSwatchColors", ['#ff8900', '#4888ff', '#7bd642', '#8a3ab9', '#ffd200', '#cf1c96', '#55acee', '#11b08c', '#2c4aaa', '#bd081c', '#ff0000', '#000000']);
      const recentColors = this.cache.retrieve(this.cacheKey);
      this.recentColors = (0, _array.A)(recentColors) || (0, _array.A)([]);
    }
    closeColorPicker() {
      this.pickr?.hide();
    }
    destroyColorPicker() {
      this.pickr?.destroyAndRemove();
    }
    initializeColorPicker(element) {
      const defaultColor = this.args.selectedColor || this.swatchColors[0];
      this.pickr = _pickr.default.create({
        el: element,
        theme: 'monolith',
        appClass: 'color-picker',
        default: defaultColor,
        defaultRepresentation: 'HEXA',
        lockOpacity: true,
        sliders: 'h',
        swatches: this.swatchColors,
        components: {
          hue: true,
          interaction: {
            input: true
          }
        }
      });
      const pickrInstance = this.pickr.getRoot();
      this.pickrElement = pickrInstance.app;
      if (this.args.pickrContainerClass) pickrInstance.root.classList.add(this.args.pickrContainerClass);
      const colorPalette = this.pickrElement.querySelector('.pcr-selection');
      const hexInput = this.pickrElement.querySelector('.pcr-result');
      const interactionElement = this.pickrElement.querySelector('.pcr-interaction');
      const swatchElement = this.pickrElement.querySelector('.pcr-swatches');
      const whiteSwatchElement = swatchElement?.children[0];
      const orDividerElement = document.createElement('div');
      orDividerElement.classList.add('cCP--stylePicker__divider');
      orDividerElement.textContent = this.intl.t('linkinbio.color_picker.or');
      const labelElement = document.createElement('label');
      labelElement.classList.add('u--text--hair', 'cCP--colorPickerInput__label', 'u--ellipsis');
      labelElement.textContent = this.intl.t('linkinbio.color_picker.hex_code');
      interactionElement?.prepend(labelElement);
      this.recentColorsElement = document.createElement('div');
      this.recentColorsElement?.setAttribute('id', this.recentColorsId);
      this.recentColorsElement.classList.add('recent-colors');
      this.headerElement = document.createElement('div');
      this.headerElement?.setAttribute('id', this.headerId);

      // Appends elements in the correct order
      this.pickrElement.prepend(this.headerElement);
      this.pickrElement?.append(orDividerElement);
      if (swatchElement) this.pickrElement?.append(swatchElement);
      this.pickrElement.appendChild(this.recentColorsElement);
      whiteSwatchElement?.classList.add('is--white');
      whiteSwatchElement?.setAttribute('data-test-id', '#FFFFFF');
      if (!this.args.hasAccess) {
        this.upgradeElement = document.createElement('div');
        this.upgradeElement?.setAttribute('id', this.upgradeId);
        this.upgradeElement.classList.add('upgrade');
        this.headerElement.after(this.upgradeElement);
        colorPalette?.classList.add('o--btn--disabled');
        swatchElement?.classList.add('o--btn--disabled');
        hexInput?.classList.add('u--mute');
        hexInput?.setAttribute('disabled', 'true');
        orDividerElement?.classList.add('u--mute');
      } else {
        this.pickr.on('change', color => {
          this.args.onSelectColor(color.toHEXA().toString());
          this.pickr?.applyColor();
        })?.on('changestop', (_source, instance) => {
          _classPrivateMethodGet(this, _addRecentColor, _addRecentColor2).call(this, instance._color.toHEXA().toString());
        });
      }
      this.pickr.on('init', instance => {
        const {
          app,
          button,
          interaction
        } = instance._root;
        app.setAttribute('data-test-id', 'color-picker-menu');
        button.setAttribute('data-test-id', 'color-picker-button');
        interaction.result.setAttribute('data-test-id', 'color-picker-input');
        hexInput?.classList.add('qa--hex_code_input');
        if (!this.args.selectedColor) this.args.onSelectColor(defaultColor);
      });
    }
    onColorChangeFromOutsideColorPicker(color) {
      const pickrColor = this.pickr?.getColor().toHEXA().toString();
      (0, _runloop.next)(() => {
        if (!this.isDestroying && !this.isDestroyed && !(0, _compareStrings.areStringsEqual)(pickrColor, color)) {
          this.pickr?.setColor(color);
          this.args.onSelectColor(color);
          _classPrivateMethodGet(this, _addRecentColor, _addRecentColor2).call(this, color);
        }
      });
    }
    openColorPicker() {
      this.pickr?.show();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "headerElement", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pickr", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pickrElement", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "recentColors", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "recentColorsElement", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "upgradeElement", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeColorPicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeColorPicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyColorPicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyColorPicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeColorPicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeColorPicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onColorChangeFromOutsideColorPicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onColorChangeFromOutsideColorPicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openColorPicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openColorPicker"), _class.prototype)), _class);
  function _addColorToCache2() {
    this.cache.add(this.cacheKey, this.recentColors, {
      expiry: this.cache.expiry(30, 'days'),
      persist: true
    });
  }
  function _isColorListed2(hexCode) {
    return this.swatchColors.includes(hexCode) || this.recentColors.includes(hexCode);
  }
  function _addRecentColor2(hexCode) {
    if (_classPrivateMethodGet(this, _isColorListed, _isColorListed2).call(this, hexCode)) {
      return;
    }
    this.recentColors.unshiftObject(hexCode);
    const MAX_COLORS = 5;
    if (this.recentColors.length > MAX_COLORS) {
      this.recentColors.popObject();
    }
    _classPrivateMethodGet(this, _addColorToCache, _addColorToCache2).call(this);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ColorPickerComponent);
});